import { render, staticRenderFns } from "./ConfirmationModalButton.vue?vue&type=template&id=63e63275&scoped=true&"
import script from "./ConfirmationModalButton.vue?vue&type=script&lang=ts&"
export * from "./ConfirmationModalButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e63275",
  null
  
)

export default component.exports